const localization = {
  en: {
    noData: 'No results were found'
  },
  es: {
    noData: 'No se encontraron resultados'
  },
  keyMapping: {
    noData: 'UFD_No_Results_Found'
  }
}

export default localization
